export default {
  boxLength: 320,
  boxHeight: 425,
  boxWidth: 220,
};
